import React from 'react'
import bg from "@/assets/reconciliation-automate/detailed/bg.svg"
import bgTablet from "@/assets/reconciliation-automate/detailed/bg-tablet.png"

import Image from 'next/image'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { montserratBold, montserratNormal,montserratMedium } from '@/assets/fonts/montserrat'
import { t } from 'i18next'
export default function DetailedRecon() {
  return (
    <div className='flex flex-col w-full h-full px-4 lg:px-8 py-16 max-w-[1280px] lg:container lg:mx-auto relative overflow-hidden'>
      <div className='flex p-8 relative overflow-hidden w-full h-full rounded-[16px] border-[1px] border-gray-cool-200 justify-center items-center flex-col'>
        <div className='absolute w-[100rem]  -z-10 flex justify-center items-center h-[100rem] md:-bottom-[40rem] lg:w-full lg:h-full lg:-top-20 lg:bg-contain lg:object-contain'>
          <Image src={bg} />
        </div>
        <div className='absolute w-[100rem] lg:hidden flex justify-center items-center -z-10 h-[100rem] md:-bottom-[40rem] lg:w-full lg:h-full lg:-top-20 lg:bg-contain lg:object-contain'>
          <Image src={bg} className="-top-[128px] md:-top-[110px] relative" />
        </div>
        <div className='absolute w-[100rem] md:hidden -z-10 flex border-2 h-[100rem] md:-bottom-[40rem] lg:w-full lg:h-full lg:-top-20 lg:bg-contain lg:object-contain'>
          <Image src={bg} className="relative -bottom-[259px]" />
        </div>
        <div className='flex flex-col w-full justify-center items-center'>
          <h1 className={`${montserratBold.className} text-[36px] text-center text-gray-cool-700 pb-3`}>{t('recon_detail_title')}</h1>
          <p className={`${montserratNormal.className} text-gray-cool-500 text-center text-[20px] pb-8`}>{t('recon_detail_description')}</p>
          <div className='w-full h-full justify-center flex'>
            <ul className='grid lg:grid-flow-col gap-8 grid-flow-row grid-cols-2 lg:grid-rows-1'>
              <li className='w-[132px] md:w-[164px] relative flex rounded-[8px] p-3 items-center justify-center bg-blue-primary-50'>
                <div className='flex w-1/4'>
                  <CheckCircleIcon className='text-blue-primary-500 relative w-[18px] md:w-6'/>
                </div>
                <p className={`${montserratMedium.className} text-base px-0 md:px-0 md:text-[20px] text-gray-cool-600`}>Sales</p>
              </li>
              <li className='w-[132px] md:w-[164px] relative flex rounded-[8px] p-3 items-center justify-center bg-blue-primary-50'>
                <div className='flex w-1/4'>
                  <CheckCircleIcon className='text-blue-primary-500 relative w-[18px] md:w-6'/>
                </div>
                <p className={`${montserratMedium.className} text-base px-0 md:px-0 md:text-[20px] text-gray-cool-600`}>Expenses</p>
              </li>
              <li className='w-[132px] md:w-[164px] relative flex rounded-[8px] p-3 items-center justify-center bg-blue-primary-50'>
                <div className='flex w-1/4'>
                  <CheckCircleIcon className='text-blue-primary-500 relative w-[18px] md:w-6'/>
                </div>
                <p className={`${montserratMedium.className} text-base px-0 md:px-0 md:text-[20px] text-gray-cool-600`}>Taxes</p>
              </li>
              <li className='w-[132px] md:w-[164px] relative flex rounded-[8px] p-3 items-center justify-center bg-blue-primary-50'>
                <div className='flex w-1/4'>
                  <CheckCircleIcon className='text-blue-primary-500 relative w-[18px] md:w-6'/>
                </div>
                <p className={`${montserratMedium.className} text-base px-0 md:px-0 md:text-[20px] text-gray-cool-600`}>Fees</p>
              </li>
              <li className='w-[132px] md:w-[164px] relative flex rounded-[8px] p-3 items-center justify-center bg-blue-primary-50'>
                <div className='flex w-1/4'>
                  <CheckCircleIcon className='text-blue-primary-500 relative w-[18px] md:w-6'/>
                </div>
                <p className={`${montserratMedium.className} text-base px-0 md:px-0 md:text-[20px] text-gray-cool-600`}>Invoices</p>
              </li>
              <li className='w-[132px] md:w-[164px] relative flex rounded-[8px] p-3 items-center justify-center bg-blue-primary-50'>
                <div className='flex w-1/4'>
                  <CheckCircleIcon className='text-blue-primary-500 relative w-[18px] md:w-6'/>
                </div>
                <p className={`${montserratMedium.className} text-base px-0 md:px-0 md:text-[20px] text-gray-cool-600`}>Bills</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
